




































































































// TODO: Enable lint.
/* eslint-disable */
import { computed, defineComponent, onMounted, reactive, ref, SetupContext } from '@vue/composition-api';
import API from '@aws-amplify/api';
import Auth from '@aws-amplify/auth';

import NavHeader from '@/components/NavHeader.vue';
import Footer from '@/components/Footer.vue';

type Concept = {
	id: string,
	project_id: string,
	cp_template_id: string,
	name?: string,
	title?: string,
	description?: string,
  image_vertical_size?: number,
	topbox?: number,
	sum_of_top2box?: number,
	created_at: string,
	updated_at: string,

  concept_image_id: string,
  cpcard_image_id: string,

  project_name: string 
};

type Spec = {
	id: string,
	concept_id: string,
	name: string,
	content: string,
	created_at: string,
	updated_at: string,
  name_placeholder: string,
  content_placeholder: string,
};


type Props = {
  id: string;
};

export default defineComponent({
  name: "ConceptDetail",
  components: {
    NavHeader,
    Footer
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  head: {
    link: [
      { rel: 'stylesheet', type: 'text/css', href: 'https://cdnjs.cloudflare.com/ajax/libs/spectrum/1.8.0/spectrum.min.css' },
      { rel: 'stylesheet', type: 'text/css', href: '/css/login/project.css' }
    ],
    script: [
      { src: "https://ajax.googleapis.com/ajax/libs/jquery/1.7/jquery.min.js" },
      { src: "https://cdnjs.cloudflare.com/ajax/libs/spectrum/1.8.0/spectrum.min.js" },
      { src: "https://cdnjs.cloudflare.com/ajax/libs/spectrum/1.8.0/i18n/jquery.spectrum-ja.min.js" },
      { src: "/js/toggle_contents.js" },
      { src: "/js/project.js" },
      { src: "/js/paretto.js" }
    ]
  },
  setup(props: Props, context: SetupContext) {
    const state = reactive({
      paretto: 'default',
      projectName: '',
      beingDeletedSpecID: '',
      concept: {} as Concept,
      imageFile: null as File | null, 
      imageData: '',
      specs: [] as Spec[],
    });

    async function load() {
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        },
        queryStringParameters: {
            pid: '',
            cid: '',
        }
      }

      API.get('dev', '/concepts/' + props.id, options).then(response => {
        console.log(response);
        state.projectName = response.data.project_name;

        state.concept = response.data.concept;
        state.concept.title = state.concept.title || '';
        state.concept.description = state.concept.description || '';

        if (state.concept.concept_image_id !== null) {
          options.queryStringParameters.pid = state.concept.project_id;
          options.queryStringParameters.cid = state.concept.id;
          API.get('dev', '/images/cpimages/' + state.concept.concept_image_id, options).then(response => {
            state.imageData = response.data.url
          }).catch(err => {
            console.log(err);
          })
        }

        if (response.data.specs !== null) {
          state.specs = response.data.specs;
        }
      }).catch(err => {
        console.log(err);
      });
    }
    load();

    async function multiCopyConcepts() {
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        },
        queryStringParameters: {
          tpid: state.concept.project_id,
        },
        body: { ids: [state.concept.id] }
      }

      API.post('dev', '/concepts/multicopy', options).then(response => {
        console.log(response);
        if (response.data!.length > 0) {
          context.root.$router.push({ name: 'ConceptEdit', params: { id: response.data[0].id } });
        } else {
          console.log("error before moving to ConceptEdit")
        }
      }).catch(err => {
        console.log(err);
      });
    }

    return {
      state,

      multiCopyConcepts
    };
  }
});
